/* eslint-disable quotes */
import React from "react";
import ReactRouterPropTypes from "react-router-prop-types";
import { FormattedMessage } from "react-intl";

import { Pluggable } from "@folio/stripes/core";

const SafeDeleteMultipleRoute = ({ match }) => {
  return (
    <Pluggable
      type="inventory-templates"
      basePath={match.path}
      // dataKey="safe-delete-multiple"
    >
      <FormattedMessage
        id="ui-inventory.templatesPluginNotAvailable"
        defaultMessage="Templates plugin not available"
      />
    </Pluggable>
  );
};

SafeDeleteMultipleRoute.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
};

export default SafeDeleteMultipleRoute;
